export const featuresMap = (featArr: { feature: string; isActive: boolean }[]) => {
  const evalFeat = (value: string) => {
    const feat = featArr.find((el) => el.feature === value);
    return feat ? !!feat.isActive : true;
  };

  return {
    'app.mixpanel': evalFeat('app.mixpanel'),
    'app.notifications.scheduler': evalFeat('app.notifications.scheduler'),
    'app.ai.suggestModifiers': evalFeat('app.ai.suggestModifiers'),
    'app.export.md': evalFeat('app.export.md'),
    'app.insights': evalFeat('app.insights'),
    'app.events': evalFeat('app.events'),
    'app.ai.suggest-controls-v2': evalFeat('app.ai.suggest-controls-v2'),
    'app.insights-v2': evalFeat('app.insights-v2'),
    'app.wizard.popup(invert)': evalFeat('app.wizard.popup(invert)'),
    'app.insights.pdf': evalFeat('app.insights.pdf'),
    'app.control.suggested-frameworks': evalFeat('app.control.suggested-frameworks'),
    'app.filters.rmp': evalFeat('app.filters.rmp'),
    'app.partner.branding': evalFeat('app.partner.branding'),
    'app.rmp.inline-edits': evalFeat('app.rmp.inline-edits'),
    'app.help.page': evalFeat('app.help.page'),
  };
};
